import AuthHandler from './AuthHandler.vue';

export default AuthHandler;
